import { isEmpty, orderBy, sortBy, get } from 'lodash';

import Mobile from '@/mixins/Mobile';
import { CLASSTING_AI_WEB } from '@/config';

export default {
  name: 'quiz',

  mixins: [
    Mobile,
  ],

  methods: {
    isMultipleChoice(page) {
      if (isEmpty(page) && isEmpty(page.page_type)) return '';
      return page.page_type.name === 'multiple_choice';
    },

    isTextEntry(page) {
      if (isEmpty(page) && isEmpty(page.page_type)) return '';
      return page.page_type.name === 'text_entry';
    },

    getQuizOptions(options) {
      if (isEmpty(options)) return [];
      return orderBy(options, ['id'], ['asc']);
    },

    isOXQuiz(options) {
      if (isEmpty(options)) return false;
      const sortedOptions = sortBy(options, 'content');
      return sortedOptions.length === 2
        && get(sortedOptions[0], 'content', '').toLowerCase() === 'o'
        && get(sortedOptions[1], 'content', '').toLowerCase() === 'x';
    },

    handleLicencePurchaseClick() {
      const link = `${CLASSTING_AI_WEB}/subscription/payment/steppay`;

      if (this.isClasstingClient) {
        return this.openWebview(`classting://link?url=${encodeURIComponent(link)}&hide_navi=1`);
      }
      return window.open(link);
    },
  },
};
